/**
 * Shared utilities for mock services.
 */

/**
 * Simulate network delay with a random duration between min and max.
 * @param {number} [min=200] - Minimum delay in milliseconds.
 * @param {number} [max=500] - Maximum delay in milliseconds.
 * @returns {Promise<void>}
 */
export const mockDelay = (min = 200, max = 500) => {
  const ms = Math.floor(Math.random() * (max - min + 1)) + min;
  return new Promise((resolve) => setTimeout(resolve, ms));
};

/**
 * Log mock service operations with consistent formatting.
 * @param {string} service - Service name.
 * @param {string} method - Method name.
 * @param {*} [args] - Optional arguments to log.
 */
export const mockLog = (service, method, args) => {
  if (process.env.NODE_ENV === 'development') {
    console.info(
      `%c[MockData] %c${service}.${method}`,
      'color: #9c27b0; font-weight: bold',
      'color: #7b1fa2',
      args !== undefined ? args : ''
    );
  }
};

/**
 * Generate a unique mock ID.
 * @returns {string}
 */
export const mockId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
};
